import { useOutletContext } from 'react-router-dom';

import ChartsBuilder from './ChartsBuilder';
import SidebarNavAnalytics from './SidebarNavAnalytics';
import { SurveyLaunchedContext } from './SurveyLaunchedPage';
import SurveyWithSidebar from 'components/layout/SurveyWithSidebar';
import ExportPageNavigation from './ExportPageNavigation';

export const Charts = () => {
  const { questions, survey, surveyId, waves } =
    useOutletContext<SurveyLaunchedContext>();

  return (
    <SurveyWithSidebar sidebarNav={<SidebarNavAnalytics surveyId={surveyId} />}>
      <ExportPageNavigation currentPage="charts" surveyId={surveyId} />
      {survey && (
        <ChartsBuilder questions={questions} survey={survey} waves={waves} />
      )}
    </SurveyWithSidebar>
  );
};
